import React, { useEffect, useState } from 'react'
import Layout from '../../../../app/Layout'
import HeaderContent from '../../General/HeaderContent'
import Breadcrumb from '../../General/Breadcrumb'
import authAxios from '../../../../config/authAxios'
import SupervisorPanel from '../AgenteMarketing/SupervisorPanel'
import RegistroAuditoria from '../AgenteMarketing/RegistroAuditoria'
import '../AgenteMarketing/AgenteMarketing.css'

/**
 * Historia 5 y 9: pagina exclusiva de Operaciones/Dirección (rol OPERACIONES,
 * mapeado hoy a id_tp_nivel_usuario=1 por decision explicita del usuario) para
 * el Nivel 2 de supervision del Agente de Marketing — independiente de lo que
 * ya calcula y ejecuta Marketing. Mismo patron de Layout/HeaderContent/
 * Breadcrumb y de selector de ciclo que AgenteMarketing.js.
 */
const SupervisionMarketing = () => {
  const [campaigns, setCampaigns] = useState([])
  const [campaignId, setCampaignId] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    authAxios.get('/admin/agente-marketing/campanas')
      .then(r => {
        const list = r.data?.data || []
        setCampaigns(list)
        if (list.length) setCampaignId(String(list[0].id_camp))
      })
      .catch(e => setError(e.response?.data?.msg || 'No fue posible listar campañas.'))
  }, [])

  return <Layout>
    <div className="am-panel">
      <HeaderContent title="Supervisión del Agente de Marketing · Nivel 2" />
      <Breadcrumb link={[
        { nombre: 'Operaciones', url: '#', icon: 'fas fa-shield-alt' },
        { nombre: 'Reportes', url: '#', icon: 'fas fa-chart-bar' },
        { nombre: 'Supervisión Nivel 2' },
      ]} />
      <div className="am-toolbar row align-items-end mx-0">
        <div className="col-md-8 mb-2">
          <label>Campaña / producto</label>
          <select className="form-control" value={campaignId} onChange={e => setCampaignId(e.target.value)}>
            <option value="">Seleccione</option>
            {campaigns.map(c => <option key={c.id_camp} value={c.id_camp}>{c.producto} · ciclo #{c.id_camp}</option>)}
          </select>
        </div>
      </div>
      {error && <div className="alert alert-danger">{error}<button className="close" onClick={() => setError('')}>&times;</button></div>}
      {!campaignId ? <p className="am-empty-tab">Seleccione un ciclo para ver su auditoría del Nivel 2.</p> : <>
        <div className="am-section">
          <div className="am-section-title"><h5>Comparativa Nivel 1 vs Nivel 2 y banderas</h5></div>
          <SupervisorPanel campaignId={campaignId} puedeAcusar={true} />
        </div>
        <div className="am-section">
          <div className="am-section-title"><h5>Bitácora de auditoría (Historia 9)</h5></div>
          <RegistroAuditoria campaignId={campaignId} />
        </div>
      </>}
    </div>
  </Layout>
}

export default SupervisionMarketing
